import React from "react";
import { useDropzone } from "react-dropzone";

type UploadType = "BANK_STATEMENT";

type Props = {
  onDrop: (acceptedFiles: File[]) => void;
  type?: UploadType;
};

const ACCEPT_MAP: Record<UploadType | "DEFAULT", any> = {
  BANK_STATEMENT: {
    "application/pdf": [".pdf"],
  },
  DEFAULT: {
    "image/*": [],
    "application/pdf": [".pdf"],
  },
};

const DragDropUploader: React.FC<Props> = ({ onDrop, type }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ACCEPT_MAP[type || "DEFAULT"],
  });

  return (
    <div
      {...getRootProps()}
      className="flex justify-center items-center bg-light-blue br-10 p-[10px] text-center cursor-pointer doc_card"
      style={{ border: "1px dashed #0066ff" }}
    >
      <input {...getInputProps()} />
      <p className="color-blue fs-12">
        {type === "BANK_STATEMENT"
          ? "Drag & Drop PDF Here"
          : "Drag & Drop Image/PDF Here"}
      </p>
    </div>
  );
};

export default DragDropUploader;
